var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67221 4.67063C3.80835 5.14161 3.22222 6.05794 3.22222 7.11111C3.22222 8.64522 4.46588 9.88889 6 9.88889C7.05367 9.88889 7.97033 9.30222 8.44117 8.43767M11 7.11111C11 4.34969 8.76144 2.11111 6 2.11111C5.75456 2.11111 5.51322 2.1288 5.27722 2.16297M1 7.11111C1 5.44828 1.81169 3.97507 3.06046 3.06603M1 1L11 11",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEyeIcon);
export default __webpack_public_path__ + "static/media/ClosedEyeIcon.f344a660f955c4f4b6e2fc3a6c563655.svg";
export { ForwardRef as ReactComponent };